import React from 'react';

const InstallmentIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8848 3.3075C12.8848 2.31 13.6948 1.5 14.6923 1.5C15.6898 1.5 16.4998 2.31 16.4998 3.3075C16.4998 4.305 15.6898 5.115 14.6923 5.115C13.6948 5.115 12.8848 4.305 12.8848 3.3075ZM9.99746 11.0694L12.165 8.2727L12.135 8.2877C12.255 8.1227 12.2775 7.9127 12.195 7.7252C12.1132 7.5377 11.9325 7.4102 11.7382 7.3952C11.535 7.3727 11.3332 7.4627 11.2125 7.6277L9.39821 9.9752L7.31996 8.3402C7.19246 8.2427 7.04246 8.20445 6.89246 8.2202C6.74321 8.2427 6.60821 8.32445 6.51746 8.44445L4.29821 11.3327L4.25246 11.4002C4.12496 11.6394 4.18496 11.9469 4.40996 12.1127C4.51496 12.1802 4.62746 12.2252 4.75496 12.2252C4.92821 12.2327 5.09246 12.1419 5.19746 12.0002L7.07996 9.57695L9.21746 11.1827L9.28496 11.2269C9.52496 11.3544 9.82496 11.2952 9.99746 11.0694ZM11.5875 2.83521C11.5575 3.02271 11.5425 3.21021 11.5425 3.39771C11.5425 5.08521 12.9075 6.44945 14.5875 6.44945C14.775 6.44945 14.955 6.42771 15.1425 6.39771V12.4495C15.1425 14.9927 13.6425 16.5002 11.0925 16.5002H5.55075C3 16.5002 1.5 14.9927 1.5 12.4495V6.90021C1.5 4.3502 3 2.83521 5.55075 2.83521H11.5875Z"
        fill="#191919"
      />
    </svg>
  );
};

export default InstallmentIcon;
